let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7S9EX")).then(() => parcelRequire('3VmKy'));